import { OState } from "./utils/types";

export const DEFAULT_SEPARATOR = "#@#";

export const partList = ["Shell", "Trim1", "Trim2", "Trim3", "Trim4", "Interlining 1", "Interlining 2", "Interlining 3", "Interlining 4"];

/**
 * @deprecated use value from setting
 */
export const partSerial = {
  Shell: 1,
  Trim1: 2,
  Trim2: 3,
  Trim3: 4,
  Trim4: 5,
  "Interlining 1": 6,
  "Interlining 2": 7,
  "Interlining 3": 8,
  "Interlining 4": 9
};

export const RollForm = {
  OPEN: "Open",
  TUBE: "Tube"
};

export const UOM = {
  METER: { value: "meter", label: "Meter", code: "m" },
  YARD: { value: "yard", label: "Yard", code: "yd" },
  FEET: { value: "feet", label: "Feet", code: "ft" },
  KILOGRAM: { value: "kilogram", label: "KG", code: "kg" },
  GRAM: { value: "gram", label: "Gram", code: "gm" },
  CENTIMETER: { value: "centimeter", label: "CM", code: "cm" },
  INCH: { value: "inch", label: "Inch", code: "inch" }
};

export const HomeView = {
  HIERARCHY: "hierarchy",
  FLAT: "flat"
};

export const FabClassification = {
  WOVEN: "Woven",
  NON_WOVEN: "Non-Woven",
  KNITTED: "Knitted"
};

export const PART_SHELL = "Shell";

export const SUIT_GARMENT = "Suit";

export const PROP_SHADE_MODERATE = "Moderate";
export const PROP_SHADE_STRICT = "Strict";

export const MULTI_PART_SEPARATE_BUNDLE = "Separate Bundle for Parts";
export const MULTI_PART_EXACT_SAME_BUNDLE = "Exact Same Bundle for Parts";
export const MULTI_PART_MANUAL_PLAN = "Manual Plan";

export const STATE_PREV_LOT_CUTTING_COMPLETED = "Cutting Completed";
export const STATE_PREV_LOT_CUTTING_NOT_COMPLETED = "Cutting Not Completed";

export const MAX_FILE_SIZE_LIMIT_COLLECTIVE = 100; // MB

export const CUT_OFF_SIZE_RATIO = 5;

export const LicenseType = {
  TRIAL: "TRIAL",
  SUBSCRIPTION: "SUBSCRIPTION",
  PERPETUAL: "PERPETUAL"
};

export const fabricIssueTypes = {
  ASSOCIATION: { name: "Association", id: "association" },
  SAMPLING: { name: "Sampling", id: "sampling" },
  WRITE_OFF: { name: "Write Off", id: "write-off" },
  RETURN_TO_MILL: { name: "Return To Mill", id: "return-mill" }
};

export const GroupingActions = {
  RUN_SHRINKAGE: "run-shrinkage",
  RUN_FINAL: "run-final",
  SAVE_SHRINKAGE: "save-shrinkage",
  SAVE_FINAL: "save-final",
  SELECT: "select",
  DELETE: "delete",
  UPDATE_PATTERN: "update-pattern"
};

export const CutPlanActions = {
  GENERATE_CUTPLAN: "generate",
  RE_GENERATE_CUTPLAN: "re_generate",
  SAVE_CUTPLAN: "default",
  UPDATE_CUTPLAN: "default",
  ADJUST_CUTPLAN: "adjust_cut_plan",
  MARRY_CUTPLANS: "marry_cut_plans",
  SEND_FOR_APPROVAL: "send_for_approval",
  APPROVE: "approve"
};

export const LayType = {
  ALL_MIX: "All Mix",
  SHADE_WISE: "Shade Wise",
  COLOR_WISE: "Color Wise",
  SIZE_GROUP_WISE: "Size Group Wise"
};

export const OrderFlowType = {
  ALLOCATION: "ALLOCATION",
  GROUPING: "GROUPING",
  CUTPLAN: "CUTPLAN",
  BUNDLING: "BUNDLING",
  FPO: "FPO"
};

export const LotType = {
  BULK: "Bulk",
  PRE_RUN: "Pre-Run"
};

export const CutPlanType = {
  ALGORITHMIC: "ALGORITHMIC",
  HYBRID: "HYBRID",
  CUSTOM: "CUSTOM"
};

export const MiscType = {
  CPL: "CPL",
  SPLICING: "Splicing",
  STEP_LAYING: "Step Laying"
};

export const LayState = {
  PENDING: 'Pending',
  IN_PROGRESS: 'In Progress',
  SENT_FOR_WASH: 'Sent for Wash',
  COMPLETED: 'Completed',
};

export const REMNANT_LAY = "Remnant Lay";

export const getStateChoices = () => {
  return [
    { id: [OState.PART_DETAIL_PENDING.state, OState.NEW.state].join(","), name: OState.NEW.state },

    { id: OState.FABRIC_ASSOCIATED.state, name: OState.FABRIC_ASSOCIATED.state },
    { id: OState.GRN_COMPLETED.state, name: OState.GRN_COMPLETED.state },
    { id: OState.FABRIC_QC_IN_PROGRESS.state, name: OState.FABRIC_QC_IN_PROGRESS.state },
    { id: OState.FABRIC_QC_COMPLETED.state, name: OState.FABRIC_QC_COMPLETED.state },
    { id: OState.FABRIC_ALLOCATED.state, name: OState.FABRIC_ALLOCATED.state },

    { id: OState.SHRINKAGE_GROUPING_COMPLETED.state, name: OState.SHRINKAGE_GROUPING_COMPLETED.state },
    { id: OState.FINAL_GROUPING_COMPLETED.state, name: OState.FINAL_GROUPING_COMPLETED.state },

    { id: [OState.MAIN_CUTPLAN_GENERATED.state, OState.CUTPLAN_IN_PROGRESS.state].join(","), name: OState.CUTPLAN_IN_PROGRESS.state },
    { id: OState.MAIN_CUTPLAN_COMPLETED.state, name: OState.MAIN_CUTPLAN_COMPLETED.state },
    { id: [OState.REMNANT_CUTPLAN_COMPLETED.state, OState.CUTPLAN_COMPLETED.state].join(","), name: OState.CUTPLAN_COMPLETED.state },

    { id: OState.ROLL_PLAN_GENERATED.state, name: OState.ROLL_PLAN_GENERATED.state },

    { id: [OState.MAIN_FEEDBACK_IN_PROGRESS.state, OState.FEEDBACK_IN_PROGRESS.state].join(","), name: OState.FEEDBACK_IN_PROGRESS.state },
    { id: OState.MAIN_FEEDBACK_COMPLETED.state, name: OState.MAIN_FEEDBACK_COMPLETED.state },

    { id: OState.RE_PLANNING_IN_PROGRESS.state, name: OState.RE_PLANNING_IN_PROGRESS.state },
    { id: OState.RE_PLANNING_COMPLETED.state, name: OState.RE_PLANNING_COMPLETED.state },

    { id: [OState.REMNANT_FEEDBACK_COMPLETED.state, OState.FEEDBACK_COMPLETED.state].join(","), name: OState.FEEDBACK_COMPLETED.state },

    { id: OState.CLOSED.state, name: OState.CLOSED.state }
  ];
};

export const stateList = [
  "New",
  "Shrinkage Grouping Completed",
  "Final Grouping Completed",
  "Main Marker Entry In Progress",
  "Main Cutplan Completed",
  "Main Feedback In Progress",
  "Main Feedback Completed",
  "Remnant Marker Entry In Progress",
  "Remnant Cutplan Completed",
  "Remnant Feedback In Progress",
  "Remnant Feedback Completed",
  "Closed"
];

export const choicesEstimationState = [
  { id: "New", name: "New" },
  { id: "Pending", name: "Pending" },
  { id: "Available", name: "Available" },
  { id: "Completed", name: "Completed" }
];

export const TaskCategory = {
  COSTING_CONSUMPTION_PENDING: "Costing Consumption Pending",
  ORDERING_CONSUMPTION_PENDING: "Ordering Consumption Pending",
  QC_PENDING: "QC Pending",
  SHRINKAGE_GROUPING_PENDING: "Shrinkage Grouping Pending",
  FINAL_GROUPING_PENDING: "Final Grouping Pending",
  CUT_PLAN_PENDING: "Cut Plan Pending",
  CUT_PLAN_APPROVAL_PENDING: "Cut Plan Approval Pending", //By Merchant
  RELEASED_CUT_PLAN: "Released Cut Plan",
  RE_PLANNED_ORDERS: "Re-Planned Orders",
  MAIN_FEDDBACK_IN_PROGRESS: "Main Feedback in Progress",
  REMNANT_FEDDBACK_IN_PROGRESS: "Remnant Feedback in Progress",
  ORDER_CLOSURE_PENDING: "Order Closure Pending"
};

export const MacroReportId = {
  AGGREGATE_RECONCILIATION: "1",
  WASTAGE: "2",
  END_BITS: "3",
  MARKER_EFFICIENCY: "4",
  CUT_QTY_ANALYSIS: "5",
  ROLL_VARIATION: "6",
  ORDER_STATUS: "7"
};

export const MicroReportId = {
  RECONCILIATION: "1",
  CUT_PLAN: "2",
  ROLL_PLAN: "3",
  FABRIC_RELEASE: "4",
  LAYSLIP_FEEDBACK: "5",
  PART_RECUTTING: "6",
  GARMENT_RECUTTING: "7",
  BUNDLE_TICKET: "8"
};

export const GROUP_WISE = "groupWise";
export const LAY_WISE = "layWise";

export const Scope = {
  READ: "read",
  WRITE: "write",
  UPDATE: "update",
  DELETE: "delete"
};

export const BundleSheetType = {
  COMPACT: "compact",
  NORMAL: "normal"
};

export const LedgerOutType = {
  BULK: "Bulk",
  SAMPLING: "Sampling",
  WRITE_OFF: "Write-Off",
  RETURN_SUPPLIER: "Return-Supplier",
  OUTSOURCE: "Outsource",
  OUTSOURCE_RETURN: "Outsource-Return",
  OUT_OF_SYSTEM: "Out-Of-System"
};

export const rollPlaneType = {
  STANDARD: "standard",
  INCLUDING_QC_REMARKS: "inc. Qc Remarks"
};
